import * as React from 'react';
import * as main from '../../main.module.scss';
import * as marathon from './style.module.scss';
export const Marathon = () => {
  return (
    <section className={marathon.marathon}>
      <div className="container">
        <h2 className={main.title}>Марафон для тех, кто хочет:</h2>
        <a href="#decide">
          <ul>
            <li>
              Легко учиться
              <br />
              даже в онлайн-формате
            </li>
            <li>Освоить новую профессию</li>
            <li>Выучить новый язык или стать айтишником</li>
            <li>Улучшить память, развить внимание и концентрацию</li>
            <li>Выйти из застоя после декрета или однообразной работы</li>
            <li>Быть ценным специалистом и не бояться сокращений</li>
            <li>Иметь много энергии и не уставать от работы</li>
            <li>Пройти все купленные курсы и прочитать отложенные книги</li>
            <li>Укрепить уверенность в себе</li>
          </ul>
        </a>
      </div>
    </section>
  );
};
